import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";
import moment from 'moment';

const CarMaintenance = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, carId }) => {
  const apiCall = useApiCall();

  const validationSchema = yup.object({
    cost: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    maintenanceDate: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    nextMaintenanceKm: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    nextMaintenanceDate: yup
      .string('This Field is Required')
      .required('This Field is Required')
  });

  const formik = useFormik({
    initialValues: {
      cost: '',
      maintenanceDate: '',
      nextMaintenanceKm: '',
      nextMaintenanceDate: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      console.log("Values", values);

      let data = {
        "car_id": carId,
        //"assigned_employee":"89294",
        "maintenance_cost": values?.cost,
        "maintenance_date": moment(values?.maintenanceDate).format("DD-MM-YYYY"),
        "next_maintenance_km": values?.nextMaintenanceKm,
        "next_maintenance_date": moment(values?.nextMaintenanceDate).format("DD-MM-YYYY")
      }

      try {
        let apiRes = await apiCall({ method: "post", url: "car-maintenance", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(`${error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong"}`)
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal}`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>Add Maintenance</h4>
          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea}`}>
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Maintenance Cost</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <input
                      type="text"
                      name='cost'
                      value={formik.values.cost}
                      onChange={formik.handleChange}
                      placeholder='Enter Maintenance Cost in Number'
                    />
                    {
                      (formik.touched.cost && Boolean(formik.errors.cost)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.cost && formik.errors.cost}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Maintenance Date</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <input
                      type="date"
                      name='maintenanceDate'
                      value={formik.values.maintenanceDate}
                      onChange={formik.handleChange}
                    />
                    {
                      (formik.touched.maintenanceDate && Boolean(formik.errors.maintenanceDate)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.maintenanceDate && formik.errors.maintenanceDate}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Next Maintenance (km)</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <input
                      type="text"
                      name='nextMaintenanceKm'
                      value={formik.values.nextMaintenanceKm}
                      onChange={formik.handleChange}
                      placeholder='Next Maintenance (km)'
                    />
                    {
                      (formik.touched.nextMaintenanceKm && Boolean(formik.errors.nextMaintenanceKm)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.nextMaintenanceKm && formik.errors.nextMaintenanceKm}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Next Maintenance Date</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <input
                      type="date"
                      name='nextMaintenanceDate'
                      value={formik.values.nextMaintenanceDate}
                      onChange={formik.handleChange}
                    />
                    {
                      (formik.touched.nextMaintenanceDate && Boolean(formik.errors.nextMaintenanceDate)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.nextMaintenanceDate && formik.errors.nextMaintenanceDate}</span>
                        :
                        null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default CarMaintenance